import axios from "../utils/axios.wrapper";

// Get all quotes
export const getAllQuotes = async () => {
  const { data } = await axios.get("/quote");
  return data.items || data;
};

// Get quote by ID
export const getQuoteById = async (id) => {
  const { data } = await axios.get(`/quote/${id}`);
  return data;
};

// Create new quote
export const createQuote = async (quoteData) => {
  const { data } = await axios.post("/quote/create", quoteData);
  return data;
};

// Update quote
export const updateQuote = async (id, quoteData) => {
  console.log("From Service QUOTE DATA: ", quoteData);
  const { data } = await axios.put(`/quote/${id}`, quoteData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return data;
};

// Soft delete quote
export const softDeleteQuote = async (id) => {
  const { data } = await axios.delete(`/quote/${id}`);
  return data;
};

// Hard delete quote
export const hardDeleteQuote = async (id) => {
  const { data } = await axios.delete(`/quote/hard/${id}`);
  return data;
};

// Get active quotes
export const getActiveQuotes = async () => {
  const { data } = await axios.get("/quote/active");
  return data.items || data;
};

// Get inactive quotes
export const getInactiveQuotes = async () => {
  const { data } = await axios.get("/quote/inactive");
  return data.items || data;
};

// Get quotes by customer ID
export const getQuotesByCustomerId = async (customerId) => {
  const { data } = await axios.get(`/quote/customer/${customerId}`);
  return data.items || data;
};

// Get quotes by customer name
export const getQuotesByCustomerName = async (name) => {
  const { data } = await axios.get(`/quote/customer/by-name/${name}`);
  return data.items || data;
};

// Get quotes by date range
export const getQuotesByDateRange = async (filter) => {
  const response = await axios.post('/quote/daterange', filter);
  const data = response.data;

  return {
    items: data?.items ?? data ?? [],
    totalCount: data?.totalCount ?? data ?? 0,
  };
};

// Get quotes paginated
export const getQuotesPaginated = async (filter) => {
  const { data } = await axios.post("/quote/paginate", filter);
  return data;
};

// Publish quote
export const publishQuote = async (id) => {
  const { data } = await axios.post(`/quote/publish/${id}`);
  return data;
};

// Approve quote
export const approveQuote = async (id) => {
  const { data } = await axios.post(`/quote/approve/${id}`);
  return data;
};

// Cancel quote
export const cancelQuote = async (id) => {
  const { data } = await axios.post(`/quote/cancel/${id}`);
  return data;
};

// Transform quote to order
export const transformQuoteToOrder = async (id) => {
  const { data } = await axios.post(`/quote/${id}/to-order`);
  return data;
};

export const quoteService = {
  getAllQuotes,
  getQuoteById,
  createQuote,
  updateQuote,
  softDeleteQuote,
  hardDeleteQuote,
  getActiveQuotes,
  getInactiveQuotes,
  getQuotesByCustomerId,
  getQuotesByCustomerName,
  getQuotesByDateRange,
  getQuotesPaginated,
  publishQuote,
  approveQuote,
  cancelQuote,
  transformQuoteToOrder,
};
